import React from "react";
import { Dialog, Disclosure } from "@headlessui/react";
import CloseIconButton from "../../../../components/CloseIconButton";
import { ChevronRightIcon, NewspaperIcon } from "@heroicons/react/24/solid";
import { useRecoilState, useRecoilValue } from "recoil";
import { agmtRowData } from "../atoms/atoms";
import EditOutlineButton from "../../../../components/EditOutlineButton";
import AgmtDetails from "./AgmtDetails";
import AgmtOtherComm from "./AgmtOtherComms";
import AgmtAttachment from "./AgmtAttachment";
import AgmtSystemInfo from "./AgmtSystemInfo";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import AgmtOverrideComm from "./AgmtOverrideComm";
interface AgmtFullViewProps {
  showFullView: boolean;
  closeFullView: () => void;
  handleEditButton: (row: any) => void;
}
export const AgmtFullViewModal: React.FC<AgmtFullViewProps> = ({
  showFullView = false,
  closeFullView,
  handleEditButton,
}) => {
  const [agmtDetails] = useRecoilState(agmtRowData);
  const editPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_agreement_edit;

  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>
      <Dialog open={showFullView} onClose={() => {}} className="relative z-40">
        {/* The backdrop, rendered as a fixed sibling to the panel container */}
        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

        {/* Full-screen scrollable container */}
        <div className="fixed inset-0 overflow-y-auto">
          {/* Container to center the panel */}
          <div className="flex min-h-full items-center justify-center p-4">
            {/* The actual dialog panel  */}
            <Dialog.Panel className="relative mx-auto p-4 w-4/5 rounded bg-white border-primary border-l-4">
              <CloseIconButton onClick={() => closeFullView()} />
              <div className="flex justify-between mx-2 pb-2 border-secondary border-b-2">
                <div className="flex items-center space-x-2">
                  <div>
                    <NewspaperIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
                  </div>
                  <div className="flex flex-row items-center space-x-2 text-sm ">
                    <div className="font-medium">Agreement ID: </div>
                    <div className="">{agmtDetails.agreementRepositoryId}</div>
                  </div>
                </div>
                <div className="">
                  <div className="flex items-center gap-2">
                    {userPermissions.includes(editPermission) && (
                      <EditOutlineButton
                        buttonText="Edit"
                        className={undefined}
                        onClick={() => handleEditButton(agmtDetails)}
                        disabled={false}
                      />
                    )}
                  </div>
                </div>
              </div>

              <Disclosure defaultOpen>
                {({ open }) => (
                  <>
                    <div className="m-2 mt-4 bg-white rounded-lg box-shadow">
                      <Disclosure.Button className="disclosureBtn ml-2">
                        <ChevronRightIcon
                          className={`${
                            open ? "transform rotate-90" : ""
                          } text-gray-500 w-5 h-5 `}
                        />
                        <div className="disclosureLabel ml-2">
                          Agreement Information
                        </div>
                      </Disclosure.Button>

                      <Disclosure.Panel className="text-xs bg-white">
                        <AgmtDetails agmtDetails={agmtDetails} />
                      </Disclosure.Panel>
                    </div>
                  </>
                )}
              </Disclosure>
              <div className="grid grid-cols-1 md:grid-cols-2">
                <div>
                  <Disclosure defaultOpen>
                    {({ open }) => (
                      <>
                        <div className="m-2 bg-white rounded-lg box-shadow py-2">
                          <Disclosure.Button className="disclosureBtn ml-2">
                            <ChevronRightIcon
                              className={`${
                                open ? "transform rotate-90" : ""
                              } text-gray-500 w-5 h-5 `}
                            />
                            <div className="disclosureLabel ml-2">
                              Other Commissions
                            </div>
                          </Disclosure.Button>

                          <Disclosure.Panel className="text-xs bg-white">
                            <AgmtOtherComm agmtDetails={agmtDetails} />
                          </Disclosure.Panel>
                        </div>
                      </>
                    )}
                  </Disclosure>
                </div>
                <div>
                  <Disclosure defaultOpen>
                    {({ open }) => (
                      <>
                        <div className="m-2 bg-white rounded-lg box-shadow py-2">
                          <Disclosure.Button className="disclosureBtn ml-2">
                            <ChevronRightIcon
                              className={`${
                                open ? "transform rotate-90" : ""
                              } text-gray-500 w-5 h-5 `}
                            />
                            <div className="disclosureLabel ml-2">
                              Attachment
                            </div>
                          </Disclosure.Button>

                          <Disclosure.Panel className="text-xs bg-white">
                            <AgmtAttachment
                              sourceFile={agmtDetails.sourceLink}
                            />
                          </Disclosure.Panel>
                        </div>
                      </>
                    )}
                  </Disclosure>
                </div>
                <div>
                  <Disclosure defaultOpen>
                    {({ open }) => (
                      <>
                        <div className="m-2 bg-white rounded-lg box-shadow py-2">
                          <Disclosure.Button className="disclosureBtn ml-2">
                            <ChevronRightIcon
                              className={`${
                                open ? "transform rotate-90" : ""
                              } text-gray-500 w-5 h-5 `}
                            />
                            <div className="disclosureLabel ml-2">
                              Override Commissions
                            </div>
                          </Disclosure.Button>

                          <Disclosure.Panel className="text-xs bg-white">
                            <AgmtOverrideComm agmtDetails={agmtDetails} />
                          </Disclosure.Panel>
                        </div>
                      </>
                    )}
                  </Disclosure>
                </div>
              </div>

              <Disclosure defaultOpen>
                {({ open }) => (
                  <>
                    <div className="m-2 bg-white rounded-lg box-shadow py-2">
                      <Disclosure.Button className="disclosureBtn ml-2">
                        <ChevronRightIcon
                          className={`${
                            open ? "transform rotate-90" : ""
                          } text-gray-500 w-5 h-5 `}
                        />
                        <div className="disclosureLabel ml-2">
                          System Information
                        </div>
                      </Disclosure.Button>

                      <Disclosure.Panel className="text-xs bg-white">
                        <AgmtSystemInfo agmtDetails={agmtDetails} />
                      </Disclosure.Panel>
                    </div>
                  </>
                )}
              </Disclosure>
            </Dialog.Panel>
          </div>
        </div>
      </Dialog>
    </>
  );
};
